import { useTranslation } from 'react-i18next'

import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'
import Text from '../../../Text'

import * as styles from './RequestWizardAIWizardFilledChip.module.css'

import CheckIcon from '../../../../icons/checkmark.svg'

function RequestWizardAIWizardFilledChip() {
  const { t } = useTranslation()

  return (
    <div className={styles.chip}>
      <IconNG
        Icon={CheckIcon}
        color={ICON_COLOR.AiPrimary}
        size={ICON_HEIGHT_16}
      />
      <Text className={styles.chipText}>
        {t('Wizard.AIWizardFilledChipKey')}
      </Text>
    </div>
  )
}

export default RequestWizardAIWizardFilledChip
